import { Fieldset, VStack } from '@chakra-ui/react';
import { CockpitFormSeparator } from '@components/cockpit/layouts/CockpitFormLayout';
import { FormInputString } from '@components/common/form';
import { FormUnitNumberInput } from '@components/common/form/FormUnitInputNumber';
import { TimeUnits, UnitTypes } from '@utils/unit.utils';

import { CommonConfiguration } from '@/types/sensor/sensors';

import { ClassificationInput, PlatformInput } from './CommonFormInputs';

const commonGeneralFormValidationFields: (keyof CommonConfiguration)[] = ['name', 'marks'];

function CommonGeneralForm() {
  return (
    <Fieldset.Root>
      <VStack width="100%" gap={5} alignItems="start">
        <FormInputString label="name" />
        <PlatformInput />
      </VStack>
    </Fieldset.Root>
  );
}

export const commonGeneralStep = {
  label: 'general',
  component: CommonGeneralForm,
  validationFields: commonGeneralFormValidationFields,
};

const commonDetectionFormValidationFields: (keyof CommonConfiguration)[] = [
  'defaultTargetClassification',
  'trackLostTime',
  'trackDeleteTime',
  'horizontalPrecision',
  'verticalPrecision',
];

function CommonDetectionForm() {
  return (
    <Fieldset.Root>
      <VStack width="100%" gap={5} alignItems="start">
        <ClassificationInput />
        <CockpitFormSeparator />
        <FormUnitNumberInput
          label="trackLostTime"
          width="100px"
          unitType={UnitTypes.TIME}
          defaultUnit={TimeUnits.SECONDS}
        />
        <FormUnitNumberInput
          label="trackDeleteTime"
          width="100px"
          unitType={UnitTypes.TIME}
          defaultUnit={TimeUnits.SECONDS}
        />
        <CockpitFormSeparator />
        <FormUnitNumberInput label="horizontalPrecision" width="130px" unitType={UnitTypes.DISTANCE} />
        <FormUnitNumberInput label="verticalPrecision" width="130px" unitType={UnitTypes.HEIGHT} />
      </VStack>
    </Fieldset.Root>
  );
}

export const commonDetectionStep = {
  label: 'detection',
  component: CommonDetectionForm,
  validationFields: commonDetectionFormValidationFields,
};

const commonMonitoringFormValidationFields: (keyof CommonConfiguration)[] = ['phoneNumber'];

function CommonMonitoringForm() {
  return (
    <Fieldset.Root>
      <VStack width="100%" gap={5} alignItems="start">
        <FormInputString label="phoneNumber" required={false} />
        <FormUnitNumberInput
          label="warningNonDetectionTimeoutThreshold"
          width="100px"
          unitType={UnitTypes.TIME}
          defaultUnit={TimeUnits.DAYS}
          required={false}
        />
        <FormUnitNumberInput
          label="nonDetectionTimeoutThreshold"
          width="100px"
          unitType={UnitTypes.TIME}
          defaultUnit={TimeUnits.DAYS}
          required={false}
        />
      </VStack>
    </Fieldset.Root>
  );
}

export const commonMonitoringStep = {
  label: 'monitoring',
  component: CommonMonitoringForm,
  validationFields: commonMonitoringFormValidationFields,
};
